export default __webpack_public_path__ + "static/media/Tutorial-Step-3.1.8e0931c5.jpg";